export { CaloriesIcon } from "./calories-icon";
